import React, { Component } from "react";
import { DatePicker } from "/src/component/general/DatePicker";
import Select from "react-select";

import { STATES_OPT, MOVEMENTS_OPT } from "../../config/const";
import { MERCHANDISER_EDITOR } from "../../config/lang";

import { translate } from "../../util/util";
import { valueObject } from "../../util/util";

// International format (E.164): leading +, a country code, then the number — digits only,
// 7–15 total, first digit non-zero. Not tied to any specific country.
const PHONE_RE = /^\+[1-9]\d{6,14}$/;

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = { imgError: false, phoneError: "" };
  }

  onPhoneChange = value => {
    this.props.onChange("phone_number", value);
    const invalid = value && !PHONE_RE.test(value);
    this.setState({ phoneError: invalid ? translate(MERCHANDISER_EDITOR, "phone_invalid", this.props.me.language) : "" });
  };

  handleSave = () => {
    const phone = this.props.item && this.props.item.phone_number;
    if (phone && !PHONE_RE.test(phone)) {
      this.setState({ phoneError: translate(MERCHANDISER_EDITOR, "phone_invalid", this.props.me.language) });
      return;
    }
    this.props.submit();
  };

  render() {
    let { item, me } = this.props;
    return (
      <div className="mp-edit">
        <div className="mp-edit-avatar-section">
          {item?.photo && !this.state.imgError ? (
            <img src={item.photo} className="mp-edit-avatar" onError={() => this.setState({ imgError: true })} />
          ) : (
            <div className="mp-edit-avatar-fallback">
              <span className="material-symbols-outlined">person</span>
            </div>
          )}
        </div>

        <div className="mp-edit-grid">
          <div className="mp-edit-col">
            <div className="mp-form-group">
              <label className="mp-form-label">{translate(MERCHANDISER_EDITOR, "name", me.language)}</label>
              <input
                type="text"
                className="mp-form-input"
                placeholder="Enter first name"
                value={item && item.first_name}
                onChange={e => this.props.onChange("first_name", e.target.value)}
              />
            </div>

            <div className="mp-form-group">
              <label className="mp-form-label">{translate(MERCHANDISER_EDITOR, "surname", me.language)}</label>
              <input
                type="text"
                className="mp-form-input"
                placeholder="Enter last name"
                value={item && item.last_name}
                onChange={e => this.props.onChange("last_name", e.target.value)}
              />
            </div>

            <div className="mp-form-group">
              <label className="mp-form-label">{translate(MERCHANDISER_EDITOR, "phone_number", me.language)}</label>
              <input
                type="text"
                className={"mp-form-input" + (this.state.phoneError ? " mp-form-input--error" : "")}
                placeholder="+XXXXXXXXXXX"
                value={item && item.phone_number}
                onChange={e => this.onPhoneChange(e.target.value)}
              />
              {this.state.phoneError && (
                <div className="mp-field-error" style={{ color: "#c0392b", fontSize: "12px", marginTop: "4px" }}>
                  {this.state.phoneError}
                </div>
              )}
            </div>

            <div className="mp-form-group">
              <label className="mp-form-label">{translate(MERCHANDISER_EDITOR, "movement", me.language)}</label>
              <Select
                options={MOVEMENTS_OPT}
                value={valueObject(item.movement, MOVEMENTS_OPT)}
                onChange={o => this.props.onChange("movement", o.value)}
                className="mp-select"
              />
            </div>

            {this.props.isNew && (
              <div className="mp-form-group">
                <label className="mp-form-label">{translate(MERCHANDISER_EDITOR, "password", me.language)}</label>
                <input
                  type="text"
                  className="mp-form-input"
                  placeholder="Password"
                  value={item && item.password}
                  onChange={e => this.props.onChange("password", e.target.value)}
                />
              </div>
            )}
          </div>

          <div className="mp-edit-col">
            <div className="mp-form-group">
              <label className="mp-form-label">{translate(MERCHANDISER_EDITOR, "date_of_enrollment", me.language)}</label>
              <DatePicker selected={new Date(item.date_joined)} className="mp-form-input" onChange={date => this.props.onChange("date_joined", date)} />
            </div>

            <div className="mp-form-group">
              <label className="mp-form-label">{translate(MERCHANDISER_EDITOR, "deactivation_date", me.language)}</label>
              <DatePicker selected={new Date(item.date_deactivated)} className="mp-form-input" onChange={date => this.props.onChange("date_deactivated", date)} />
            </div>

            <div className="mp-form-group">
              <label className="mp-form-label">{translate(MERCHANDISER_EDITOR, "date_till_newbie", me.language)}</label>
              <DatePicker selected={new Date(item.date_till_newbie)} className="mp-form-input" onChange={date => this.props.onChange("date_till_newbie", date)} />
            </div>

            <div className="mp-form-group">
              <label className="mp-form-label">{translate(MERCHANDISER_EDITOR, "status", me.language)}</label>
              <Select
                options={STATES_OPT}
                value={valueObject(item.is_active, STATES_OPT)}
                onChange={o => this.props.onChange("is_active", o.value)}
                className="mp-select"
              />
            </div>

            {this.props.isNew && (
              <div className="mp-form-group">
                <label className="mp-form-label">{translate(MERCHANDISER_EDITOR, "repeat_password", me.language)}</label>
                <input
                  type="text"
                  className="mp-form-input"
                  placeholder="Repeat password"
                  value={item && item.password2}
                  onChange={e => this.props.onChange("password2", e.target.value)}
                />
              </div>
            )}
          </div>
        </div>

        {this.props.errors.length > 0 && (
          <div className="mp-edit-errors">
            {this.props.errors.join(", ")}
          </div>
        )}

        <div className="mp-edit-actions">
          <button className="mp-save-btn" onClick={this.handleSave}>
            <span className="material-symbols-outlined">save</span>
            {translate(MERCHANDISER_EDITOR, "save_changes_btn", me.language)}
          </button>
        </div>
      </div>
    );
  }
}

export default Edit;
